import { FC, useState } from 'react';
import { Box, Checkbox, Collapse, Typography } from '@mui/material';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useFormikContext } from 'formik';

interface IForm {
	SendDocumentsByPost: boolean;
}

interface ISendDocumentsByPostProps {
	onChange: (checked: boolean) => void;
}

const SendDocumentsByPost: FC<ISendDocumentsByPostProps> = ({ onChange }) => {
	const formik = useFormikContext<IForm>();
	const [isSelected, setIsSelected] = useState<boolean>(false);

	const handleExpand = () => {
		setIsSelected((prev) => !prev);
	};

	return (
		<Box>
			<Box>
				<Typography variant='body1' gutterBottom fontWeight='bold'>
					Document Delivery Preferences
				</Typography>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'left',
						flexDirection: 'row',
						alignItems: 'left',
					}}
				>
					<Typography variant='subtitle1' sx={{ mb: 1, textAlign: 'left' }}>
						We will always provide you with digital copies of your documents via email. We can also provide you with a
						printed copy, however, we ask that you consider the environment before requesting. If you would also like to
						receive copies by post, please click{' '}
						<Typography color='primary' component='span' onClick={handleExpand} sx={{ cursor: 'pointer' }}>
							here.
						</Typography>
					</Typography>
				</Box>
				<Collapse in={isSelected}>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'flex-start',
							flexDirection: 'row',
							width: '100%',
							alignItems: 'center',
						}}
					>
						<Checkbox
							icon={<CircleOutlinedIcon />}
							checkedIcon={<CheckCircleIcon />}
							name='sendDocumentsByPost'
							id='sendDocumentsByPost'
							checked={formik.values.SendDocumentsByPost}
							onChange={(event) => {
								onChange(event.target.checked);
							}}
							sx={{
								'& .MuiSvgIcon-root': { fontSize: '4rem' },
							}}
						/>
						<Typography sx={{ textAlign: 'left' }}>Please send me a copy of my documents in the post</Typography>
					</Box>
				</Collapse>
			</Box>
		</Box>
	);
};

export default SendDocumentsByPost;
